import apiClient from '../api';

export const getUpcomingAndPastMeetingsByOrgId = (data, header) => apiClient.get(`/meetings/list/${data}`, header);
export const getAllThirtyDaysMeetings = (header) => apiClient.get(`/meetings/list`, header);
